import type { ApiResponse } from '../types';
import { SSEMarketBody } from './type';
import { KyInstance, Options } from 'ky';

/**
 * Subscribe to market events
 */
export const subscribe = async (api: KyInstance, json: SSEMarketBody, options?: Options): Promise<ApiResponse> => {
  return await api.post<ApiResponse>('subscribe', { json, ...options }).json();
};

/**
 * Unsubscribe from market events
 */
export const unsubscribe = async (api: KyInstance, json: SSEMarketBody, options?: Options): Promise<ApiResponse> => {
  return await api.post<ApiResponse>('unsubscribe', { json, ...options }).json();
};
